import { Button, InfoPage } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";
import { useTracker } from "../../hooks/useTracker";
import useTranslation from "../../hooks/useTranslation";

export default function NotFoundPage({ isProjectPage }: { isProjectPage?: boolean }) {
  const tracker = useTracker();
  const navigation = useNavigation();
  const { t, m } = useTranslation();

  const title = isProjectPage
    ? t(m.ErrorMessage.ProjectNotFound)
    : t(m.ErrorMessage.DesignNotFound);
  const message = isProjectPage
    ? t(m.ErrorMessage.ProjectNotFoundDescription)
    : t(m.ErrorMessage.DesignNotFoundDescription);
  return (
    <InfoPage
      title={title}
      description={message}
      primaryCTA={
        <Button
          variant="grayscale"
          onClick={() => {
            tracker.trackGoToDashboard({
              location: "request_access_page",
              destination: "shared_with_me",
            });
            navigation.goToProfile();
          }}
        >
          {t(m.ErrorMessage.GoToDashboard)}
        </Button>
      }
    />
  );
}
